import { useState } from "react";
import { UI, BTN } from "../constants/tokens";
import { Card } from "./Card";
import SymbolAutocomplete from "./SymbolAutocomplete";
import DateField from "./DateField";

export default function AddStock({ onAdd, type }) {
  const [open,    setOpen]    = useState(false);
  const [symbol,  setSymbol]  = useState("");
  const [shares,  setShares]  = useState("");
  const [price,   setPrice]   = useState("");
  const [buyDate, setBuyDate] = useState("");
  const [error,   setError]   = useState("");

  const inp = {
    background: UI.surface.page, border: `1px solid ${UI.line.hairline}`, borderRadius: 6,
    padding: "10px 12px", color: UI.text.primary, fontSize: 16, outline: "none",
    width: "100%", boxSizing: "border-box",
  };

  // A portfolio holding without a real purchase price cannot show a P&L —
  // fabricating one (e.g. defaulting to $100) produces a return % that
  // isn't real. Require the field instead of inventing a number.
  const submit = () => {
    setError("");
    if (!symbol.trim()) { setError("הזן סימול מניה"); return; }
    if (type === "portfolio" && !(+price > 0)) { setError("הזן שער רכישה אמיתי · לא ניתן לחשב תשואה בלעדיו"); return; }
    onAdd({
      symbol:  symbol.trim().toUpperCase(),
      shares:  +shares  || 1,
      buyPrice: type === "portfolio" ? +price : +price || 100,
      buyDate: buyDate  || null,
    });
    setSymbol(""); setShares(""); setPrice(""); setBuyDate(""); setOpen(false);
  };

  if (!open) return (
    <button onClick={() => setOpen(true)} style={{ ...BTN.secondary, background: UI.accent.soft, color: UI.accent.base, border: `1px solid ${UI.accent.hairline}`, padding: 14, width: "100%" }}>
      + הוסף מניה
    </button>
  );

  return (
    <Card style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div style={{ fontWeight: 700, fontSize: 18, color: UI.text.primary }}>הוספת מניה</div>
      <SymbolAutocomplete value={symbol} onChange={setSymbol} placeholder="סימול (AAPL, TSLA...)" inputStyle={inp} />
      {type === "portfolio" && <>
        <input value={shares}  onChange={e => setShares(e.target.value)}  placeholder="כמות יחידות"  type="number" style={inp}/>
        <input value={price}   onChange={e => setPrice(e.target.value)}   placeholder="שער רכישה ($) · שדה חובה" type="number" style={inp}/>
        <div>
          <div style={{ fontSize: 13, color: UI.text.muted, marginBottom: 4, fontWeight: 600 }}>תאריך רכישה</div>
          <DateField value={buyDate} onChange={setBuyDate} aria-label="תאריך רכישה"/>
        </div>
      </>}
      {error && <div style={{ fontSize: 13, color: UI.caution, fontWeight: 600 }}>{error}</div>}
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={submit} className="si-btn-gold" style={{ ...BTN.primary, flex: 1, padding: 10 }}>הוסף</button>
        <button onClick={() => setOpen(false)} style={{ ...BTN.secondary, padding: "10px 16px", fontSize: 16 }}>ביטול</button>
      </div>
    </Card>
  );
}
